import script from "./AssetPerformance.vue?vue&type=script&setup=true&lang=js"
export * from "./AssetPerformance.vue?vue&type=script&setup=true&lang=js"

import "./AssetPerformance.vue?vue&type=style&index=0&id=11b07a9e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11b07a9e"]])

export default __exports__